<template>
  <div class="MainSiteNavDesktop">
    <Container class="navbar">
      <LogoLink :url="content.homepagePath" class="logoLink" />
      <NavbarItems
        :items="content.topLevelItems"
        class="navbarItems"
        v-bind="{ setHasShade }"
      />
      <!-- 'data-testing-target' attribute is used in Ghost Inspector tests -->
      <SmallCtaButton
        class="--outline demoCta"
        v-bind="content.cta"
        data-testing-target="siteNavCtaButtonDesktop"
      />
      <LoginLink v-if="content.login && content.login.url" :content="content.login" class="login" />
      <LoginMenu v-if="content.login && content.login.entries" :content="content.login" class="login" />
    </Container>
  </div>
</template>

<script>
import LoginLink from './LoginLink.vue'
import LoginMenu from './LoginMenu.vue'
import LogoLink from '../shared/LogoLink.vue'
import NavbarItems from './NavbarItems.vue'

export default {
  components: {
    LoginLink,
    LoginMenu,
    LogoLink,
    NavbarItems,
  },
  props: {
    content: {
      type: Object,
      required: true,
    },
    setHasShade: {
      type: Function,
    },
  },
}
</script>

<style scoped>

.MainSiteNavDesktop {
  position: relative;
  background-color: var(--bg-color-white);
  --navbar-height: 5.25rem;
  --menu-text-color-light: #9CA3AB;
  --menu-text-color-dark: #0F2D4C;
  --menu-link-hover-color: #2A63A4;
}

.navbar {
  height: var(--navbar-height);
  position: relative;  /* Required for .dropdown { width: 100% } in NavbarItem to work correctly */
  display: flex;
  align-items: center;
}

.logoLink {
  flex-shrink: 0;
}

.logoLink + .navbarItems {
  margin-left: auto;
}

.navbarItems + .demoCta {
  margin-left: var(--spacing-8);
}

.demoCta + .login {
  margin-left: var(--spacing-9);
}
</style>
